import { useState, useEffect } from "react";
import { CircularProgress } from "@mui/material";
import { StafSekreService } from "../../../../services/Integration/staf-sekre/StafSekreService";
import {
  SIDANG_S1_TYPE,
  SIDANG_S2_TYPE,
  SIDANG_S3_TYPE,
} from "../../../../utils/constants/SidangType.constants";
import {
  SimpleCardContainer,
  SimpleCardContent,
} from "../../../../components/common/SimpleCard/SimpleCard";
import DisplayPieChartByJenjang from "./DisplayPieChartByJenjang";

const DashboardAdminStatistik = ({ term }) => {
  const [isLoading, setIsLoading] = useState(true);
  const [statistik, setStatistik] = useState({ s1: {}, s2: {}, s3: {} });

  useEffect(() => {
    getStatistikByTerm();
  }, [term]);

  const getStatistikByTerm = async () => {
    setIsLoading(true);
    await StafSekreService.getStatsDashboardStafSekre(term)
      .then((response) => {
        if (response.status === 200) {
          setStatistik(response.data);
        } else {
          console.log(response);
        }
      })
      .catch((error) => console.log(error));  
    setIsLoading(false);
  };

  return (
    <>
      {isLoading ? (
        <div className="flex justify-center">
          <CircularProgress />
        </div>
      ) : (
        <div className="pt-7">
          <div className="flex flex-row gap-8">
            <SimpleCardContainer>
              <SimpleCardContent>
                <DisplayPieChartByJenjang
                  jenjangType={SIDANG_S1_TYPE}
                  dataByJenjang={statistik.s1}
                  titleChart={"Jenjang Sarjana (S1)"}
                />
              </SimpleCardContent>
            </SimpleCardContainer>

            <SimpleCardContainer>
              <SimpleCardContent>
                <DisplayPieChartByJenjang
                  jenjangType={SIDANG_S2_TYPE}
                  dataByJenjang={statistik.s2}
                  titleChart={"Jenjang Magister (S2)"}
                />
              </SimpleCardContent>
            </SimpleCardContainer>

            <SimpleCardContainer>
              <SimpleCardContent>
                <DisplayPieChartByJenjang
                  jenjangType={SIDANG_S3_TYPE}
                  dataByJenjang={statistik.s3}
                  titleChart={"Jenjang Doktor (S3)"}
                />
              </SimpleCardContent>
            </SimpleCardContainer>
          </div>
        </div>
      )}
    </>
  );
};

export default DashboardAdminStatistik;
